import { useContext } from 'react'
import { useRestQuery } from '@/lib/hook/tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'
import ProfileContext from '@/components/Context/ProfileContext'
import { WishlistProduct, toWishlistArray } from './useWishlistIds'

type WishlistResponse = {
  products: Record<string, WishlistProduct> | WishlistProduct[]
}

export const useWishlist = (options?: { enabled?: boolean }) => {
  const { isAuthenticated } = useContext(ProfileContext)

  const query = useRestQuery<WishlistResponse>({
    ...ApiQueryEndpoint.USERS.GET_WISHLIST,
    queryKey: ['wishlist'],
    enabled: isAuthenticated && (options?.enabled ?? true),
    staleTime: 1000 * 60 * 5,
  })

  const products = toWishlistArray(query.data?.products)

  return {
    products,
    total: products.length,
    isLoading: query.isLoading,
    refetch: query.refetch,
  }
}
